import { Directive, Input, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';
import { LoginService } from '../services/login.service';

@Directive({
  selector: '[hasRole]'
})
export class HasRoleDirective implements OnInit {
  private roles: readonly string[] = [];
  private isHidden = true;

  @Input()
  set hasRole(roles: string | readonly string[]) {
    if (roles) {
      this.roles = Array.isArray(roles) ? roles : [roles];
    }
    this.updateView();
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private loginService: LoginService
  ) {}

  ngOnInit() {
    this.updateView();
  }

  private updateView() {
    if (!this.roles?.length) {
      if (this.isHidden) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.isHidden = false;
      }
      return;
    }

    const hasRole = this.roles.some(role => this.loginService.hasRole(role));

    if (hasRole && this.isHidden) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.isHidden = false;
    } else if (!hasRole && !this.isHidden) {
      this.viewContainer.clear();
      this.isHidden = true;
    }
  }
}
